import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';

function Table({ rows = [], columns = [], getRowId, loading, pageSize = null, searchQuery = '' }) {
  const customLocaleText = {
    noRowsLabel: 'There are no records to display',
  };

  const query = searchQuery?.toLowerCase() || '';

  const filteredRows = React.useMemo(() => {
    if (!query) return rows;
    return rows.filter((row) =>
      columns.some((column) => {
        const value = row[column.field];
        return value?.toString().toLowerCase().includes(query);
      })
    );
  }, [rows, columns, query]);

  return (
    <Box>
      <DataGrid
        getRowId={getRowId}
        rows={filteredRows}
        columns={columns}
        autoHeight
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: pageSize || 5,
            },
          },
        }}
        pageSizeOptions={[5, 10, 25, 50]}
        disableRowSelectionOnClick
        localeText={customLocaleText}
        loading={loading}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? 'row-even' : 'row-odd'
        }
        sx={{
          border: 'none',
          fontSize: '13.5px',
          color: '#3b4a63',

          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#ffffff',
            borderBottom: '1px solid #eef2f8',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            fontSize: '11.5px',
            fontWeight: 700,
            color: '#93a0b5',
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
          },
          '& .MuiDataGrid-cell': {
            borderBottom: 'none',
            padding: '0 24px',
          },
          '& .MuiDataGrid-columnHeader': {
            padding: '0 24px',
          },
          '& .row-even': {
            backgroundColor: '#f8fbfe',
          },
          '& .row-odd': {
            backgroundColor: '#ffffff',
          },
          '& .MuiDataGrid-row:hover': {
            backgroundColor: '#eef4fb !important',
          },
          '& .MuiDataGrid-footerContainer': {
            borderTop: '1px solid #eef2f8',
          },
          '& .MuiTablePagination-root': {
            fontSize: '12.5px',
            color: '#93a0b5',
          },
          '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
            outline: 'none',
          },
          '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
            outline: 'none',
          },
        }}
      />
    </Box>
  );
}

export default Table;